import { createTheme } from '@mantine/core';

// Claude DESIGN.md に基づいたデザイントークン
export const theme = createTheme({
  primaryColor: 'brand',

  colors: {
    // Terracotta brand — #c96442 が index[5]
    brand: [
      '#fdf5f2', '#f9e8e0', '#f0cbbb', '#e6a98e', '#db8764',
      '#c96442', '#b55a3a', '#9c4c30', '#7d3c26', '#5e2d1b',
    ],
    // Warm neutrals — Mantine の gray を yellow-brown undertone で上書き
    gray: [
      '#faf9f5', '#f5f4ed', '#e8e6dc', '#d1cfc5', '#b0aea5',
      '#87867f', '#5e5d59', '#4d4c48', '#3d3d3a', '#141413',
    ],
  },

  white: '#faf9f5',   // ivory
  black: '#141413',   // near black

  defaultRadius: 'md',

  fontFamily: '"Lora", Georgia, serif',
  fontFamilyMonospace: 'ui-monospace, monospace',

  headings: {
    fontFamily: '"Lora", Georgia, serif',
    fontWeight: '500',
    sizes: {
      h1: { fontSize: '2rem',    lineHeight: '1.20' },
      h2: { fontSize: '1.6rem',  lineHeight: '1.25' },
      h3: { fontSize: '1.3rem',  lineHeight: '1.30' },
      h4: { fontSize: '1.1rem',  lineHeight: '1.35' },
      h5: { fontSize: '1rem',    lineHeight: '1.40' },
    },
  },

  components: {
    AppShell: {
      styles: {
        header: {
          background: 'var(--mantine-color-body)',
          borderBottom: '1px solid var(--app-color-border)',
        },
      },
    },
    Card: {
      defaultProps: { radius: 'md', shadow: 'none' },
      styles: {
        root: {
          background: 'var(--app-color-surface)',
          border: '1px solid var(--app-color-border)',
          transition: 'box-shadow 0.15s ease',
        },
      },
    },
    Paper: {
      styles: {
        root: {
          background: 'var(--app-color-surface)',
        },
      },
    },
    Modal: {
      styles: {
        content: { background: 'var(--app-color-surface)' },
        header:  { background: 'var(--app-color-surface)' },
      },
    },
    Button:        { defaultProps: { radius: 'md' } },
    Badge:         { defaultProps: { radius: 'sm' } },
    TextInput:     { defaultProps: { radius: 'md' } },
    PasswordInput: { defaultProps: { radius: 'md' } },
    MultiSelect:   { defaultProps: { radius: 'md' } },
    Select:        { defaultProps: { radius: 'md' } },
    NumberInput:   { defaultProps: { radius: 'md' } },
    ActionIcon:    { defaultProps: { radius: 'md' } },
  },
});

// MantineProvider の cssVariablesResolver に渡す設定
// --mantine-color-body を parchment/near-black に上書きし、
// カスタム変数 --app-color-surface / --app-color-border を定義する
export const cssVariablesResolver = () => ({
  variables: {},
  light: {
    '--mantine-color-body': '#f5f4ed',   // parchment
    '--app-color-surface':  '#faf9f5',   // ivory (カード・Paper 用)
    '--app-color-border':   '#f0eee6',   // border cream
  },
  dark: {
    '--mantine-color-body': '#141413',   // near black
    '--app-color-surface':  '#1e1e1c',   // dark surface
    '--app-color-border':   '#30302e',   // dark border
  },
});
